// noinspection JSUnresolvedReference

import Environment from '../config/Environment';
import Debug from './Debug';
import Text from './Text';

const PRINT_LOG = true;

export default class ExternalAnalytics {
    static toAnalytics(source, section, category) {
        const metricData = source ? source.toExternalMetric() : undefined;
        const metadata = {
            eventCategory: this.getEventCategory(category),
            market: 'pe',
            formStepName: this.getFormStepName(section),
            journeyName: 'qr autoatencion',
            journeyType: 'interes',
            pageCategory: 'landing comercial',
            pageOwner: 'terminales'
        };
        return {...metricData, ...metadata};
    };

    static getFormStepName(section) {
        switch (section) {
            case 'not-found-view':
                return '0 - qr autoatencion - 404';
            case 'product-view':
                return '1 - qr autoatencion - ficha de producto';
            case 'cart-view':
                return '2 - qr autoatencion - carrito';
            case 'identification-view':
                return '3 - qr autoatencion - identificacion';
            case 'address-copy-view':
                return '4 - qr autoatencion - direccion tienda';
            case 'scanner-view':
                return '5 - qr autoatencion - escaner';
            default:
                return undefined;
        }
    };

    static getEventCategory(category) {
        switch (category) {
            case 'page':
                return 'full page';
            case 'link':
                return 'enlace';
            case 'tab':
                return 'tab';
            case 'button':
                return 'btn';
            case 'modal':
                return 'modal';
            case 'modal-button':
                return 'modal - btn';
            case 'radio-button':
                return 'radio button';
            default:
                return undefined;
        }
    };

    static formatEventLabel(label) {
        return label ? Text.normalize(label) : undefined;
    };

    static sendMetric(eventData) {
        if (PRINT_LOG) Debug.printToLog('info', '[Metric]', eventData);
        try {
            if (Environment.current === 'local') {
                if (PRINT_LOG) Debug.printToLog('info', '[Metric] Metrics are disabled in a local environment');
            } else window.dataLayer.push(eventData);
        } catch (error) {
            Debug.printToLog('error', error);
        }
    };

    static viewItem(source, section) {
        try {
            if (!source) return;
            const data = this.toAnalytics(source, section, undefined);
            const eventData = {
                event: 'view_item',
                ecommerce: {
                    items: [{
                        item_name: data.name,
                        item_id: data.id,
                        price: data.reducedPrice,
                        item_brand: data.brand,
                        item_category: data.type,
                        item_category2: data.model,
                        item_category3: data.memory,
                        item_category4: data.subtype,
                        item_category5: data.color,
                        item_variant: data.normalPrice,
                        item_list_id: undefined,
                        item_list_name: undefined,
                        index: undefined,
                        quantity: 1
                    }],
                },
                market: data.market,
                segment: data.segment,
                form_step_name: data.formStepName,
                journey_name: data.journeyName,
                journey_type: data.journeyType,
                page_category: data.pageCategory,
                page_owner: data.pageOwner
            };
            this.sendMetric(eventData);
        } catch (error) {
            Debug.printToLog('error', error);
        }
    };

    static addToCart(source, section) {
        try {
            if (!source) return;
            const data = this.toAnalytics(source, section, undefined);
            const eventData = {
                event: 'add_to_cart',
                ecommerce: {
                    items: [{
                        item_name: data.name,
                        item_id: data.id,
                        price: data.reducedPrice,
                        item_brand: data.brand,
                        item_category: data.type,
                        item_category2: data.model,
                        item_category3: data.memory,
                        item_category4: data.subtype,
                        item_category5: data.color,
                        item_variant: data.normalPrice,
                        item_list_id: undefined,
                        item_list_name: undefined,
                        index: undefined,
                        quantity: 1
                    }],
                },
                market: data.market,
                segment: data.segment,
                form_step_name: data.formStepName,
                journey_name: data.journeyName,
                journey_type: data.journeyType,
                page_category: data.pageCategory,
                page_owner: data.pageOwner
            };
            this.sendMetric(eventData);
        } catch (error) {
            Debug.printToLog('error', error);
        }
    };

    static goTo(source, section, category, label) {
        try {
            const data = this.toAnalytics(source, section, category); // In this event, the source can be undefined.
            const eventData = {
                event: 'go_to',
                event_category: data.eventCategory,
                event_action: 'go_to',
                event_label: this.formatEventLabel(label),
                market: data.market,
                segment: data.segment,
                form_step_name: data.formStepName,
                journey_name: data.journeyName,
                journey_type: data.journeyType,
                page_category: data.pageCategory,
                page_owner: data.pageOwner
            };
            this.sendMetric(eventData);
        } catch (error) {
            Debug.printToLog('error', error);
        }
    };

    static productDetailsInteraction(source, section, category, label) {
        try {
            if (!source) return;
            const data = this.toAnalytics(source, section, category);
            const eventData = {
                event: 'interaction',
                event_category: data.eventCategory,
                event_action: 'interaction',
                event_label: this.formatEventLabel(label),
                market: data.market,
                segment: data.segment,
                form_step_name: data.formStepName,
                journey_name: data.journeyName,
                journey_type: data.journeyType,
                product_name: data.name,
                product_id: data.id,
                product_type: data.type,
                page_category: data.pageCategory,
                page_owner: data.pageOwner
            };
            this.sendMetric(eventData);
        } catch (error) {
            Debug.printToLog('error', error);
        }
    };

    static load(source, section, category, label) {
        try {
            if (!source) return;
            const data = this.toAnalytics(source, section, category);
            const eventData = {
                event: 'load',
                event_category: data.eventCategory,
                event_action: 'info',
                event_label: this.formatEventLabel(label),
                market: data.market,
                segment: data.segment,
                form_step_name: data.formStepName,
                journey_name: data.journeyName,
                journey_type: data.journeyType,
                page_category: data.pageCategory,
                page_owner: data.pageOwner
        };
            this.sendMetric(eventData);
        } catch (error) {
            Debug.printToLog('error', error);
        }
    };

    static clickToAction(source, section, category, label) {
        try {
            if (!source) return;
            const data = this.toAnalytics(source, section, category);
            const eventData = {
                event: 'click_to_action',
                event_category: data.eventCategory,
                event_action: 'click_to_action',
                event_label: this.formatEventLabel(label),
                market: data.market,
                segment: data.segment,
                form_step_name: data.formStepName,
                journey_name: data.journeyName,
                journey_type: data.journeyType,
                page_category: data.pageCategory,
                page_owner: data.pageOwner
            };
            this.sendMetric(eventData);
        } catch (error) {
            Debug.printToLog('error', error);
        }
    };

    static viewCart(sources, section) {
        try {
            if (!sources || sources.length === 0) return;
            let eventData = {event: 'view_cart'};
            let itemsData = [];
            sources.forEach((source) => {
                const itemData = this.toAnalytics(source, section, undefined);
                if (itemData) {
                    itemsData.push({
                        item_name: itemData.name,
                        item_id: itemData.id,
                        price: itemData.reducedPrice,
                        item_brand: itemData.brand,
                        item_category: itemData.type,
                        item_category2: itemData.model,
                        item_category3: itemData.memory,
                        item_category4: itemData.subtype,
                        item_category5: itemData.color,
                        item_variant: itemData.normalPrice,
                        item_list_id: undefined,
                        item_list_name: undefined,
                        index: undefined,
                        quantity: 1
                    });
                    if (!eventData.market) {
                        eventData.market = itemData.market;
                        eventData.segment = itemData.segment;
                        eventData.form_step_name = itemData.formStepName;
                        eventData.journey_name = itemData.journeyName;
                        eventData.journey_type = itemData.journeyType;
                        eventData.page_category = itemData.pageCategory;
                        eventData.page_owner = itemData.pageOwner;
                    }
                }
            });
            eventData.ecommerce = {items: itemsData};
            this.sendMetric(eventData);
        } catch (error) {
            Debug.printToLog('error', error);
        }
    };

    static beginCheckout(sources, section) {
        try {
            if (!sources || sources.length === 0) return;
            let eventData = {event: 'begin_checkout'};
            let itemsData = [];
            sources.forEach((source) => {
                const itemData = this.toAnalytics(source, section, undefined);
                if (itemData) {
                    itemsData.push({
                        item_name: itemData.name,
                        item_id: itemData.id,
                        price: itemData.reducedPrice,
                        item_brand: itemData.brand,
                        item_category: itemData.type,
                        item_category2: itemData.model,
                        item_category3: itemData.memory,
                        item_category4: itemData.subtype,
                        item_category5: itemData.color,
                        item_variant: itemData.normalPrice,
                        item_list_id: undefined,
                        item_list_name: undefined,
                        index: undefined,
                        quantity: 1
                    });
                    if (!eventData.market) {
                        eventData.market = itemData.market;
                        eventData.segment = itemData.segment;
                        eventData.form_step_name = itemData.formStepName;
                        eventData.journey_name = itemData.journeyName;
                        eventData.journey_type = itemData.journeyType;
                        eventData.page_category = itemData.pageCategory;
                        eventData.page_owner = itemData.pageOwner;
                    }
                }
            });
            eventData.ecommerce = {items: itemsData};
            this.sendMetric(eventData);
        } catch (error) {
            Debug.printToLog('error', error);
        }
    };

    static identificationInteraction(source, section, category, label) {
        try {
            if (!source) return;
            const data = this.toAnalytics(source, section, category);
            const eventData = {
                event: 'interaction',
                event_category: data.eventCategory,
                event_action: 'interaction',
                event_label: this.formatEventLabel(label),
                market: data.market,
                segment: data.segment,
                form_step_name: data.formStepName,
                journey_name: data.journeyName,
                journey_type: data.journeyType,
                page_category: data.pageCategory,
                page_owner: data.pageOwner
            };
            this.sendMetric(eventData);
        } catch (error) {
            Debug.printToLog('error', error);
        }
    };

    static addShippingInfo(sources, section, address) {
        try {
            if (!sources || sources.length === 0) return;
            let eventData = {event: 'add_shipping_info'};
            let itemsData = [];
            sources.forEach((source) => {
                const itemData = this.toAnalytics(source, section, undefined);
                if (itemData) {
                    itemsData.push({
                        item_name: itemData.name,
                        item_id: itemData.id,
                        price: itemData.reducedPrice,
                        item_brand: itemData.brand,
                        item_category: itemData.type,
                        item_category2: itemData.model,
                        item_category3: itemData.memory,
                        item_category4: itemData.subtype,
                        item_category5: itemData.color,
                        item_variant: itemData.normalPrice,
                        item_list_id: undefined,
                        item_list_name: undefined,
                        index: undefined,
                        quantity: 1
                    });
                    if (!eventData.market) {
                        eventData.market = itemData.market;
                        eventData.segment = itemData.segment;
                        eventData.form_step_name = itemData.formStepName;
                        eventData.journey_name = itemData.journeyName;
                        eventData.journey_type = itemData.journeyType;
                        eventData.page_category = itemData.pageCategory;
                        eventData.page_owner = itemData.pageOwner;
                        eventData.address = btoa(address);
                    }
                }
            });
            eventData.ecommerce = {items: itemsData};
            this.sendMetric(eventData);
        } catch (error) {
            Debug.printToLog('error', error);
        }
    };
}